module.exports = __webpack_public_path__ + "static/media/slide3_article1.9aa42e1a.jpg";